import { PkSpinner } from '@uefadigital/panenka-react';
import { memo } from 'react';

import type { Slot } from '../types';
import { SlotType } from '../types';

import CardContainer from './CardContainer';

const fakeSlot = {
  type: SlotType.PLACEHOLDER,
} as Slot;

const PlaceholderCard = () => (
  <CardContainer slot={fakeSlot}>
    <PkSpinner className='pk-d--flex pk-w--100 pk-h--100' />
  </CardContainer>
);

export default memo(PlaceholderCard);
